import axios from "../http";

let module = "/pay";

function addClewPayRecord(data) {
    return axios.post(module, data);
}

function queryPayRecordByClewId(data) {
    return axios.get(module+"/"+data.id);
}

export default {
    addClewPayRecord,
    queryPayRecordByClewId,
}
